<template>
    <div class="permission">
        <div class="p_container">
            <el-row class="p_header">
                <span class="span1">{{name}}</span>
                <div class="quick_set_block" v-if="admin_id != 0">
                    <span class="span2">快速分配权限:</span>
                     <span v-for="(item,index) in role_list" :key="'role_'+item.id">
                        <button v-if="item.status == 1" @click="quickSet(item.id), bgFlag=index"  :class="{'actived': bgFlag==index}">{{ item.name }}</button>
                     </span>
                </div>
                <button class="lastone" @click="save">保存</button>
            </el-row>
            <el-row class="margin_b">
                <div>

                </div>
                <div class="header">
                    <span>菜单列表</span><span>功能列表</span><span>授权<input class="authAll" v-model="authAllValue" @change="authAll($event.target)" type="checkbox"></span>
                </div>
                <div class="wrap mar-top-20" v-for="(items) in list" :key="items.id">
                    <div class="content1">
                        <div class="item1">
                            <span class="mar-l-10">{{items.name}}</span><span class="triangle"></span>
                        </div>
                        <div class="item2">
                        </div>
                        <div class="item3">
                            <input type="checkbox" :ref="'row_'+items.id" @change="selectPath($event.target,items)">
                        </div>
                    </div>
                    <div v-for="(item, index) in items.child" :key="index">
                        <div class="content2">
                            <div class="item1">
                                <div>
                                    <span>{{item.name}}</span> <span class="triangle"></span>
                                </div>
                            </div>
                            <div class="item2">
                            </div>
                            <div class="item3">
                                <input type="checkbox" :ref="'row_'+item.id" @change="selectGroup($event.target,item,items)">
                            </div>
                        </div>
                        <div class="content3" v-for="(i, ind) in item.child" :key="ind">
                            <div class="item1">
                                <span class="ball"></span><span>{{i.name}}</span>
                            </div>
                            <div class="item2 center" >
                                <span v-for="(btn, inx) in i.child" :key="inx" class="inline-block">
                                    <label unselectable="on" :style="'-moz-user-select:none;'+btn.code=='sell-report-price-update'?'color:#b21111;':''" onselectstart="return false;" class="mar_r flex_center"><input type="checkbox" @change="chagnePrower(btn, i)" :checked="selected.indexOf(btn.id) >= 0">{{ btn.name }}</label>
                                </span>
                            </div>
                            <div class="item3">
                                <input type="checkbox" :ref="'row_'+i.id" @change="selectRow($event.target,i,item)">
                            </div>
                        </div>
                    </div>
                </div>
            </el-row>
        </div>
    </div>
</template>
<style scoped>
    .authAll{background-color: #fff;position: relative;top:-2px;margin-left:5px;}
    /* .authAll:before{background-color: #fff!important;} */
    .permission{ width: 100%; background: #eee; padding: 10px 0 0 10px; }
    .permission .p_container{height: 100%; width: 100%;background: #fff; padding:10px 20px;}
    .permission .p_container .p_header{height: 50px; display: flex; align-items: flex-end;padding-bottom:10px;}
    .permission .p_container .span1{font-size: 22px; font-weight: bold; margin: 0 20px;}
    .permission .p_container .span2{font-size: 14px; margin-right: 10px;}
    .permission .p_container  button{padding: 3px 10px;margin-right: 10px; cursor: pointer; border-radius: 3px;outline: none;border:1px solid #333;background: transparent;}
    .permission .p_container  button.lastone{padding: 6px 15px;margin: 0 10px; cursor: pointer; border-radius: 3px;outline: none;border:none; background: #b21111;color: #fff;}
    .permission .p_container  button.lastone:hover{background: #EC1313;border-color: #EC1313;color: #fff;}
    .permission .p_container  button.btn1:hover{background: #F9A602;border:1px solid #F9A602;color:#fff;}
    .margin_b{margin-bottom: 30px;}
    .actived{background: #F9A602!important; border-color: #F9A602!important;color:#fff!important}
    /*修改框架样式 */
    /* .el-checkbox__input.is-checked .el-checkbox__inner {background-color: #fff;border-color: #333;background: #333;}
    .el-checkbox__inner:hover{border-color: #333;}
    .el-checkbox__input.is-checked .el-checkbox__inner{border-color: #333;}
    .el-checkbox__input.is-focus .el-checkbox__inner{border-color: #333;}
    .el-checkbox__input.is-checked .el-checkbox__inner{color: #333;}
    .el-checkbox__input.is-checked+.el-checkbox__label {color: #333;}
    .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {background-color: #333;border-color: #333;} */
    .el-table--border, .el-table--group {border-radius: 6px; box-shadow: 0 0 8px rgb(209, 208, 208);}
    .mar_r {margin-right: 30px;}
    .mar_l_5 {margin-left: 5px;}
    .mar-top-20{margin-top: 20px;}
    input[type="checkbox"] {width: 12px;height: 12px;display: inline-block;text-align: center;vertical-align: middle;line-height: 12px;position: relative;border-radius: 2px;background: #ccc;}
    input[type="checkbox"]::before {content: "";position: absolute;top: 0;left: 0;background: #ccc;width: 100%;height: 100%; border: 1px solid #d9d9d9;border-radius: 2px;}
    input[type="checkbox"]:checked::before {content: "\2713";background-color: #333;position: absolute;top: 0;left: 0;width: 100%;border: 1px solid #333;color: #fff;font-size: 14px;font-weight: 500;}
    .item2 input[type="checkbox"]{ margin-right: 8px; }
    .ball {display: inline-block;width: 6px;height: 6px;border-radius: 50%;background: #b21111;margin-right: 10px;margin-left: 88px;}
    .header{height: 50px;width: 100%;border-radius: 8px;overflow: hidden;}
    .header span{display: inline-block;background: #b21111;height: 100%;text-align: center;color:#fff;font-size:14px; font-weight:700;padding-top:5px;}
    .header span:first-child{width: 20%;}
    .header span:nth-child(2){width: 70%; border-right: 1px solid #fff;border-left: 1px solid #fff;box-sizing: border-box;}
    .header span:last-child{width: 10%;}
    .content1, .content2, .content3{display:flex; width: 100%;min-height: 35px; font-size: 14px;border-bottom: 1px solid #eee;box-sizing: border-box;background: #fff;}
    .item1{display: inline-block;width: 20%;height: 100%;  box-sizing: border-box;display: flex;align-items: center; }
    .item2{display: inline-block;width: 70%;height: 100%;}
    .item3{display: inline-block;width: 10%;height: 100%; display: flex; justify-content: center; align-items: center;}
    .content2 .item1 div{height: 100%; display: flex;justify-content: flex-end;align-items: center; width: 100px;}
    .content3 .item1 div .ball{padding-left: 200px;}
    .wrap{width: 100%; height: 100%;position: relative; top: -40px; background: #fff;  box-sizing: border-box; border-radius: 8px;overflow: hidden;border: 1px solid #eee;box-shadow:0 0 4px #ccc;}
    .mar-l-10{margin-left: 10px;}
    .center{display:flex;align-items:center;justify-content:left;flex-wrap: wrap;}
    .inline-block{display:flex; align-items: center; }
    .quick_set_block{ display:inline-block; max-width:700px; white-space: nowrap; overflow: auto; }
</style>

<script>
export default {
    data() {
        return {
            btnLists: ['销售','采购'],
            tableData1: [{ role: "系统管理员", status: "启用" }],
            dialogFormVisible: false,
            form: { rolename: "" },
            rules: {
                rolename: [{ required: true, message: "请填写角色名", trigger: "blur" }]
            },
            formLabelWidth: "80px",
            authAllValue:false,
            list : [],
            role_list : [],
            selected : [],
            admin_id : 0,
            role_id : 0,
            name : "",
            bgFlag: 999
        };
    },
    computed: {},
    created() {
        this.getList();
        this.getRoleList();
    },
    mounted() {
    },
    methods: {
        authAll(e){
            this.list.forEach(item=>{
                this.selectPath(e,item)
                this.checkPath(item)
            })
        },
        //新增
        add() {
            this.dialogFormVisible = true;
        },
        getList(){
            window.axios.post("/erp/module.list.company").then(response=>{
                this.list = response.data.data;
            }).then(()=>{
                if(localStorage.hasOwnProperty('dw_setting_auth_admin_id')){
                    this.admin_id = localStorage.getItem("dw_setting_auth_admin_id");
                    localStorage.removeItem('dw_setting_auth_admin_id');
                }
                if(localStorage.hasOwnProperty('dw_setting_auth_role_id')){
                    this.role_id = localStorage.getItem("dw_setting_auth_role_id");
                    localStorage.removeItem('dw_setting_auth_role_id');
                }
                this.$nextTick(function(){
                    this.getPrower();
                })
            }).catch(() => {
                this.tip("列表加载错误","warning")
            })
        },
        getRoleList(){
            this.postFunc("/erp/role.list",{},response=>{
                if(response.data.code == 0){
                    // do something
                    this.role_list = response.data.data;
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        getPrower(){
            let url = "";
            let t="";
            let data={user_id:"",role_id:""};
            if (this.admin_id != 0) {
                url = '/erp/module.list.user';
                t = "user";
                data.user_id=this.admin_id;
            }
            if (this.role_id != 0) {
                url = '/erp/module.list.role';
                t = "role";
                data.role_id=this.role_id;
            }
            this.postFunc(url,data,response=>{
                this.name = response.data.data[t+'_name'];
                this.selected = response.data.data.ids;
                this.selected.forEach((number,index)=>{
                    let num = number;
                    this.selected[index]=parseInt(num)
                })
                this.checkSelected(this.list);
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        // 向下选择
        chagnePrower(item,parent){
            let index = this.selected.indexOf(item.id);
            if (index >= 0) {
                this.selected.splice(index, 1);
            } else {
                this.selected.push(item.id);
            }
            this.checkRow(parent);
        },
        selectRow(e,item,parent){
            if (item.hasOwnProperty('child')) {
                if (e.checked) {
                    this.selectedToAll(item);
                } else {
                    this.removeFromSelect(item);
                }
            }
            if (parent) {
                this.checkGroup(parent);
            }
        },
        selectGroup(e,item,parent){
            item.child.forEach( children => {
                let target = this.$refs["row_"+children.id][0];
                target.checked = e.checked;
                this.selectRow(target,children);
            })
            if (parent) {
                this.checkPath(parent);
            }
        },
        selectPath(e,item){
            item.child.forEach( children => {
                let target = this.$refs["row_"+children.id][0];
                target.checked = e.checked;
                this.selectGroup(target,children);
            })
        },
        selectedToAll(item){
            item.child.forEach( child => {
                let index = this.selected.indexOf(child.id);
                if (index < 0) {
                    this.selected.push(child.id);
                }
            })
        },
        removeFromSelect(item){
            item.child.forEach( child => {
                let index = this.selected.indexOf(child.id);
                if (index >= 0) {
                    this.selected.splice(index, 1);
                }
            })
        },
        // 向上选中
        checkRow(item){
            let boolean = true;
            item.child.forEach(child => {
                boolean = boolean && this.selected.indexOf(child.id) >= 0;
            })
            let target = this.$refs['row_'+item.id][0];
            let parent;
            target.checked = boolean;
            this.list.forEach( items => {
                if (items.hasOwnProperty('child')) {
                    items.child.forEach(ite => {
                        if (ite.hasOwnProperty('child')) {
                            if (ite.id == item.parent_id) {
                                parent = ite;
                            }
                        }
                    })
                }
            })
            this.checkGroup(parent);
        },
        checkGroup(item){
            let boolean = true;
            let parent=null;
            item.child.forEach(child => {
                let target = this.$refs['row_'+child.id][0];
                boolean = boolean && target.checked;
            })
            let target = this.$refs['row_'+item.id][0];
            target.checked = boolean;
            this.list.forEach( items => {
                if (items.hasOwnProperty('child')) {
                    items.child.forEach(() => {
                        if (items.id == item.parent_id) {
                            parent = items;
                        }
                    })
                }
            })
            this.checkPath(parent);
        },
        checkPath(item){
            let boolean = true;
            item.child.forEach(child => {
                let target = this.$refs['row_'+child.id][0];
                boolean = boolean && target.checked;
            })
            let target = this.$refs['row_'+item.id][0];
            target.checked = boolean;
        },
        checkSelected(list){
            list.forEach( item => {
                if(item.level == 3){
                    if (item.hasOwnProperty('child')) {
                        this.checkRow(item)
                    }
                } else if (item.hasOwnProperty('child')) {
                    this.checkSelected(item.child);
                }
            })
        },
        // 快速设置
        quickSet(id){
            this.postFunc("/erp/module.list.role",{role_id:id},response=>{
                if(response.data.code == 0){
                    this.selected = response.data.data.ids;
                    this.checkSelected(this.list);
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        // 保存
        save(){
            let url = "";
            let data={user_id:"",role_id:"",module_ids : this.selected};
            if (this.admin_id != 0) {
                url = '/erp/module.set.user';
                data.user_id = this.admin_id;
            }
            if (this.role_id != 0) {
                url = '/erp/module.set.role';
                data.role_id = this.role_id;
            }
            this.postFunc(url,data,()=>{
                this.tip("保存成功","success")
                this.$root.$children[0].$children[0].removeCurTab();
            },error=>{
                this.tip(error.data.message,"warning")
            })
        }
    }
};
</script>
